import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from "vue";

/**
 * Types
 */

type Props = {
  text: string;
  isDisabled?: boolean;
  isChecked?: boolean;
  isClosable?: boolean;
  variant?: "dark" | "light";
};

/**
 * Component
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'ChipsFilter',
  props: {
    text: null,
    isDisabled: { type: Boolean, default: false },
    isChecked: { type: Boolean, default: false },
    isClosable: { type: Boolean, default: false },
    variant: { default: "light" }
  },
  emits: ["click", "close", "mouseover", "mouseleave"],
  setup(__props: any, { emit }: { emit: ({
  (e: "click"): void;
  (e: "close"): void;
  (e: "mouseover"): void;
  (e: "mouseleave"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { text: string, isDisabled: boolean, isChecked: boolean, isClosable: boolean, variant: "dark" | "light" };





const handleClick = () => {
  emit("click");
};

const handleMouseOver = () => {
  emit("mouseover");
};

const handleMouseLeave = () => {
  emit("mouseleave");
};

const handleClose = () => {
  emit("close");
}

const isLightVariant = computed(() => props.variant === "light");

const iconColor = computed(() => {
  if (isLightVariant.value) {
    return "secondary";
  }

  return "primaryWhite";
});

const chipClass = computed(() => {
  const BASE_CLASS = "chips-filter";

  if (isLightVariant.value) {
    return `${BASE_CLASS} chips-filter--light`;
  }

  return `${BASE_CLASS} chips-filter--dark`;
});

return { __sfc: true,props, emit, handleClick, handleMouseOver, handleMouseLeave, handleClose, isLightVariant, iconColor, chipClass }
}

})